<template>
    <div class="city">
        <p v-for="(item,index) in address.area_list" :key="index" @click="choosed(item)">{{item}}</p>
    </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
        address:''
    };
  },
  created() {
    let id =  sessionStorage.getItem('member_id')
    axios.get(HPV_URL+"/api/rightArea/"+id).then(res => {
      this.address = res.data;
      console.log(res.data);
    });
  },
  methods: {
    choosed(hosp){
      sessionStorage.setItem('hospital',hosp)
      this.$router.push({
        path: "/hospital"
      });
    }
  },
};
</script>

<style scoped>
p {
  margin: 0 20px;
  height: 48px;
  line-height: 48px;
  font-size: 16px;
  border-bottom: 1px solid #dfdfdf;
  padding: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/hospinfo.vue